import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getDefaultRoute } from '../../utils/permissions';

export default function RoleBasedRedirect() {
  const { user } = useAuth();
  const target = user ? getDefaultRoute(user.role) : '/login';
  return <Navigate to={target} replace />;
}
